import { Button } from 'components/common/button/Button';

interface InvitationInfoFormProps {
    name: string;
    phone: string;
    onNameChange: (value: string) => void;
    onPhoneChange: (value: string) => void;
    onNext: () => void;
    isNextEnabled: boolean;
}

export const InvitationInfoForm = ({
    name,
    phone,
    onNameChange,
    onPhoneChange,
    onNext,
    isNextEnabled
}: InvitationInfoFormProps) => {
    return (
        <>
            {/* Progress Indicator */}
            <div className="info-progress">
                <div className="progress-step active">1</div>
                <div className="progress-line active"></div>
                <div className="progress-step">2</div>
                <div className="progress-line"></div>
                <div className="progress-step">3</div>
            </div>

            <div className="progress-labels">
                <span className="progress-label active">기본 정보</span>
                <span className="progress-label">위치 권한</span>
                <span className="progress-label">완료</span>
            </div>

            {/* Title Section */}
            <div className="info-title-section">
                <h1 className="info-title">반가워요!</h1>
                <p className="info-subtitle">
                    모임에 참여하기 위해<br />
                    간단한 정보를 입력해 주세요
                </p>
            </div>

            {/* Form */}
            <div className="info-form">
                {/* Name Input */}
                <div className="form-group">
                    <label className="form-label">
                        이름 <span className="required">*</span>
                    </label>
                    <input
                        type="text"
                        className="form-input"
                        placeholder="홍길동"
                        value={name}
                        onChange={(e) => onNameChange(e.target.value.slice(0, 10))}
                        maxLength={10}
                    />
                    <div className="form-hint">
                        <span className="hint-text">다른 참여자들에게 표시될 이름이에요</span>
                    </div>
                </div>

                {/* Phone Input */}
                <div className="form-group">
                    <label className="form-label">
                        전화번호 <span className="required">*</span>
                    </label>
                    <input
                        type="tel"
                        className="form-input"
                        placeholder="010-0000-0000"
                        value={phone}
                        onChange={(e) => onPhoneChange(e.target.value)}
                        maxLength={13}
                    />
                    <div className="form-hint">
                        <span className="hint-text">모임 알림을 받으실 번호를 입력해 주세요</span>
                    </div>
                </div>
            </div>

            {/* Privacy Notice */}
            <div className="privacy-notice">
                <div className="notice-icon">🔒</div>
                <div className="notice-text">
                    입력하신 정보는 이 모임에서만 사용되며,<br />
                    안전하게 보호됩니다.
                </div>
            </div>

            {/* Next Button */}
            <div className="invitation-info-footer">
                <Button
                    text="다음"
                    disabled={!isNextEnabled}
                    onPress={onNext}
                />
            </div>
        </>
    );
};
